import { render } from "./ShopActionList.vue?vue&type=template&id=31083a94"
import script from "./ShopActionList.vue?vue&type=script&lang=js"
export * from "./ShopActionList.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__